import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { GroupedPlayerRewardDto, PlayerRewardListDto, PlayerRewardParams } from './playerGamificationRewards.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { playerGamificationRewards } from './playerGamificationRewards.api';

export const playerGamificationRewardsOptions = {
  meRewards: (params?: PlayerRewardParams, options?: QueryOptionsOverride<PlayerRewardListDto>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerGamificationRewards, params],
    queryFn: () => playerGamificationRewards.getMeRewards(params),
    ...options,
  }),

  meGroupedRewards: (options?: QueryOptionsOverride<GroupedPlayerRewardDto[]>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerGamificationGroupedRewards],
    queryFn: () => playerGamificationRewards.getMeGroupedRewards(),
    ...options,
  }),
};
